__turbopack_context__.v({
  "clearfix": "HTMLBlock-module-scss-module__BvB9MG__clearfix",
  "column": "HTMLBlock-module-scss-module__BvB9MG__column",
  "editTitle": "HTMLBlock-module-scss-module__BvB9MG__editTitle",
  "editor": "HTMLBlock-module-scss-module__BvB9MG__editor",
  "fifth": "HTMLBlock-module-scss-module__BvB9MG__fifth",
  "flow-opposite": "HTMLBlock-module-scss-module__BvB9MG__flow-opposite",
  "fourth": "HTMLBlock-module-scss-module__BvB9MG__fourth",
  "full": "HTMLBlock-module-scss-module__BvB9MG__full",
  "half": "HTMLBlock-module-scss-module__BvB9MG__half",
  "htmlBlockContainer": "HTMLBlock-module-scss-module__BvB9MG__htmlBlockContainer",
  "htmlEditor": "HTMLBlock-module-scss-module__BvB9MG__htmlEditor",
  "row": "HTMLBlock-module-scss-module__BvB9MG__row",
  "sb-scoped-html-base": "HTMLBlock-module-scss-module__BvB9MG__sb-scoped-html-base",
  "sixth": "HTMLBlock-module-scss-module__BvB9MG__sixth",
  "third": "HTMLBlock-module-scss-module__BvB9MG__third",
  "two-fifth": "HTMLBlock-module-scss-module__BvB9MG__two-fifth",
  "two-fourth": "HTMLBlock-module-scss-module__BvB9MG__two-fourth",
  "two-sixth": "HTMLBlock-module-scss-module__BvB9MG__two-sixth",
  "two-third": "HTMLBlock-module-scss-module__BvB9MG__two-third",
});
